import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './AssignToStaffModal.css';

/**
 * Assign To Staff Modal
 * Modal for org admins to assign applications to staff members
 */
function AssignToStaffModal({
  application,
  staffMembers = [],
  onClose,
  onAssign,
  isLoading,
  currentUserId
}) {
  const { t } = useTranslation('attorney');
  const [selectedStaffId, setSelectedStaffId] = useState('');

  // Filter out current user from staff list (can't assign to self via this modal)
  const availableStaff = staffMembers.filter(m => m.userId !== currentUserId);

  const handleAssign = () => {
    if (selectedStaffId) {
      onAssign(application.id, selectedStaffId);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="assign-staff-modal" onClick={(e) => e.stopPropagation()}>
        <div className="assign-staff-modal-header">
          <h2>{t('attorney.assignStaff.title', 'Assign to Staff')}</h2>
          <button className="modal-close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="assign-staff-modal-content">
          <div className="assign-staff-app-info">
            <span className="assign-staff-app-id">{application.applicationId}</span>
            <span className="assign-staff-trademark">{application.trademark?.name || 'Unknown'}</span>
          </div>

          <div className="form-group">
            <label>{t('attorney.assignStaff.selectStaff', 'Select Staff Member')}</label>
            {availableStaff.length === 0 ? (
              <p className="assign-staff-empty">
                {t('attorney.assignStaff.noStaff', 'No other staff members available for assignment')}
              </p>
            ) : (
              <select
                value={selectedStaffId}
                onChange={(e) => setSelectedStaffId(e.target.value)}
                className="assign-staff-select"
              >
                <option value="">
                  {t('attorney.assignStaff.selectPlaceholder', '-- Select an attorney --')}
                </option>
                {availableStaff.map(staff => (
                  <option key={staff.userId} value={staff.userId}>
                    {staff.name} ({staff.email})
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>

        <div className="assign-staff-modal-footer">
          <button
            className="btn-cancel"
            onClick={onClose}
            disabled={isLoading}
          >
            {t('attorney.assignStaff.cancel', 'Cancel')}
          </button>
          <button
            className="btn-assign"
            onClick={handleAssign}
            disabled={!selectedStaffId || isLoading}
          >
            {isLoading
              ? t('attorney.assignStaff.assigning', 'Assigning...')
              : t('attorney.assignStaff.assign', 'Assign')
            }
          </button>
        </div>
      </div>
    </div>
  );
}

export default AssignToStaffModal;
